interface WhatsAppChatProps {
  className?: string;
}

const messages = [
  {
    from: 'client',
    text: 'Bom dia! Preciso de um compressor industrial 15HP, vocês têm disponível?',
    time: '08:47',
  },
  {
    from: 'agent',
    text: 'Bom dia! Sim, trabalhamos com compressores de 5HP até 75HP. O CompAr X500 (15HP) tem 125 PCM, pressão máx. 10 bar e temos pronta entrega. Envio a ficha técnica completa?',
    time: '08:47',
    badge: 'Automat IA',
  },
  {
    from: 'client',
    text: 'Sim! Qual o prazo de entrega e condições?',
    time: '08:48',
  },
  {
    from: 'agent',
    text: 'Entrega em até 3 dias úteis. Para volumes maiores negociamos. Posso agendar com nosso consultor técnico amanhã às 10h?',
    time: '08:48',
    badge: 'Automat IA',
  },
];

export default function WhatsAppChat({ className = '' }: WhatsAppChatProps) {
  return (
    <div className={`rounded-2xl overflow-hidden shadow-2xl ${className}`} style={{ maxWidth: 360 }}>
      {/* Header */}
      <div className="bg-[#075E54] px-4 py-3 flex items-center gap-3">
        <div className="w-9 h-9 rounded-full bg-coral flex items-center justify-center flex-shrink-0">
          <i className="ri-robot-line text-white text-base" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-white font-semibold text-sm leading-tight">Automat IA</p>
          <p className="text-green-200 text-xs">online agora</p>
        </div>
        <div className="w-2 h-2 rounded-full bg-green-400 flex-shrink-0" />
      </div>

      {/* Messages */}
      <div className="bg-[#ECE5DD] px-3 py-3 space-y-2" style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23c9bbad' fill-opacity='0.15'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")" }}>
        {messages.map((msg, i) => (
          <div
            key={i}
            className={`flex ${msg.from === 'client' ? 'justify-start' : 'justify-end'}`}
          >
            <div
              className={`max-w-[78%] rounded-xl px-3 py-2 shadow-sm ${
                msg.from === 'client'
                  ? 'bg-white rounded-tl-sm'
                  : 'bg-[#DCF8C6] rounded-tr-sm'
              }`}
            >
              {msg.badge && (
                <p className="text-[10px] font-bold text-[#075E54] mb-0.5">{msg.badge}</p>
              )}
              <p className="text-[13px] text-gray-800 leading-snug">{msg.text}</p>
              <div className="flex items-center justify-end gap-1 mt-0.5">
                <span className="text-[10px] text-gray-400">{msg.time}</span>
                {msg.from === 'agent' && (
                  <i className="ri-check-double-line text-[#34B7F1] text-xs" />
                )}
              </div>
            </div>
          </div>
        ))}

        {/* Typing indicator */}
        <div className="flex justify-end">
          <div className="bg-[#DCF8C6] rounded-xl rounded-tr-sm px-4 py-3 shadow-sm flex items-center gap-1">
            {[0, 1, 2].map((i) => (
              <span
                key={i}
                className="w-1.5 h-1.5 rounded-full bg-gray-500 animate-pulse-dot"
                style={{ animationDelay: `${i * 0.2}s` }}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Input bar */}
      <div className="bg-[#F0F0F0] px-3 py-2 flex items-center gap-2">
        <div className="flex-1 bg-white rounded-full px-4 py-2">
          <span className="text-gray-400 text-xs">Digite uma mensagem</span>
        </div>
        <div className="w-8 h-8 rounded-full bg-[#075E54] flex items-center justify-center">
          <i className="ri-send-plane-fill text-white text-sm" />
        </div>
      </div>
    </div>
  );
}